import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import { Button, Box } from '@mui/material';
import { AppHelper } from '../AppHelper';
import SentenceTransformView from './sentence-transformation/sentence-transform-view';
import SpaCheck from './common/spa-check';

export default function PageExerciseDetail() {
  
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  const { exerciseId } = useParams();
  
  const [isLoading, setIsLoading] = useState(true);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('VIEW');  
  const [profileId, setProfileId] = useState('');
  const [isSa, setIsSa] = React.useState(false);

  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
  });
  
  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
    if(!oUser.profileId){
    }
    if(profileId=='')
      setProfileId(oUser.profileId);

    const fetchIAM = async()=>{
      var _res = await AppHelper.apiPost('api/account/iam', {token: oUser.token});
      if(!_res || !_res.status || !_res.data || !_res.data.isSa){
        return;
      }
      setIsSa(true);
    }
    fetchIAM();
  });
  
  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");

    setIsLoading(false);
  }, []);

  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  
  const exerciseViewDone = (arg) =>{    
    setViewMode('VIEW');
  };
  return (
    <Box sx={{display:'flex'}}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading? (
        <AppLoading />
      ):(
      <>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, 
          width: '100%',
          marginTop:'50px' 
        }}
      >
        {
          viewMode=='VIEW' &&(
            <>    
            <SentenceTransformView isSa={isSa} onViewDone={exerciseViewDone} exerciseId={exerciseId}></SentenceTransformView>
            </>
          )
        }
      </Box>
      </>
      )}
      <SpaCheck></SpaCheck>
    </Box>
  );
}
